import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { EmailSetting } from 'app/shared/models/email-setting.model';
import { SettingsService } from 'app/shared/services/settings.service';
import { PasswordInputType } from 'app/shared/types/password-input-type';

@Component({
  selector: 'app-email-settings',
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.scss']
})
export class EmailSettingsComponent extends ModalBaseComponent implements OnInit {

  currentObject: EmailSetting;
  passwordType: string = 'password';
  passwordIconClass: string = 'ft-eye';
  savedSuccessfullyMessage: string;
  connectionTestedSuccessfullyMessage: string;

  constructor(public settingsService: SettingsService, protected translateService: TranslateService) {
    super(null);
  }

  ngOnInit() {
    this.initializeObject();
    this.settingsService.getSettings<EmailSetting>('/setting/email', (object) => {
      if (object) {
        this.currentObject = object;
      }
      super.initializeObject();
    });

    this.translateService.get(['settings.savedSuccessfullyMessage', 'settings.connectionTestedSuccessfullyMessage'])
      .subscribe(translations => {
        this.savedSuccessfullyMessage = translations['settings.savedSuccessfullyMessage'];
        this.connectionTestedSuccessfullyMessage = translations['settings.connectionTestedSuccessfullyMessage'];
      });
  }

  initializeObject() {
    if (this.currentObject == null) {
      this.currentObject = new EmailSetting();
    }
  }

  onSubmit(form: NgForm) {
    this.settingsService.saveSettings<EmailSetting>('/setting/email', form.value, () => this.ngOnInit(), this.savedSuccessfullyMessage);
  }

  testConnection(form: NgForm) {
    this.settingsService.testSettings<EmailSetting>('/setting/email/test', form.value, null, this.connectionTestedSuccessfullyMessage);
  }

  togglePassword() {
    if (this.passwordType == PasswordInputType.password) {
      this.passwordType = PasswordInputType.text;
      this.passwordIconClass = 'ft-eye-off';
    } else {
      this.passwordType = PasswordInputType.password;
      this.passwordIconClass = 'ft-eye';
    }
  }
}
